import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { GAEvent, trackEvent } from 'utils/analytics'

export const PageViewTracker = () => {
  const location = useLocation()

  useEffect(() => {
    trackEvent({
      event: GAEvent.PAGE_VIEW,
      page_path: location.pathname,
      page_search: location.search
    })
  }, [location.pathname, location.search])

  return null
}
